<div id="auth-code" fxLayout="column">
  <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div
      id="login-form"
      [class.mat-elevation-z2]="!isActive"
      [class.mat-elevation-z8]="isActive"
    >
      <div class="logo">
        <img
          src="../../assets/heartcare_logo.png"
          style="height: 100px; width: 100px"
        />
      </div>

      <div class="mat-display-2 title">HeartCare</div>

      <form name="resetForm" [formGroup]="forgotForm" novalidate>
        <mat-form-field appearance="fill">
          <mat-label>Authorization code </mat-label>
          <input
            matInput
            formControlName="authcode"
            type="number"
            onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
            [(ngModel)]="auth_code"
            required
          />
          <mat-error *ngIf="forgotForm.hasError('required', ['authcode'])"
            >Authorization code is required.</mat-error
          >
          <mat-error *ngIf="forgotForm.hasError('invalidCode', ['authcode'])">{{
            errMsg
          }}</mat-error>
          <!-- <mat-error *ngIf="forgotForm.hasError('invalidCode', ['authcode'])"
            >Authorization code is required.</mat-error
          > -->
        </mat-form-field>

        <button
          mat-raised-button
          color="accent"
          class="submit-button mat-body-2"
          aria-label=""
          color="accent"
          (click)="submit()"
          [disabled]="disableButton_submit || !this.auth_code"
        >
          SUBMIT
        </button>
        <button
          mat-raised-button
          color="accent"
          class="resend-button mat-body-2"
          aria-label=""
          (click)="resend()"
          [disabled]="disableButton"
          *ngIf="resend_flag == 1"
        >
          RESEND CODE
        </button>
      </form>
      <div *ngIf="resend_flag == 0">
        <div style="color: #008dc9">Request new authorization code in</div>
        <span class="custom-style">{{ counter }}</span>
        <span style="color: #008dc9; padding-left: 2px">seconds</span>
      </div>
    </div>
  </div>
</div>
